import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d4c484a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "bet-info"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "chip" }, null, -1))
const _hoisted_3 = { class: "bet-amount" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["bet-box-root", _ctx.alignment])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["div", { 'is-active': _ctx.isMouseDown, flashing: _ctx.showAnimation }])
    }, [
      _renderSlot(_ctx.$slots, "custombutton", {
        onClick: _ctx.onClicked,
        onRelease: _ctx.handleMouseUp
      }, undefined, true)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["label", `type${_ctx.color}`])
    }, _toDisplayString(_ctx.label), 3),
    (_ctx.amountOfBet > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.amountOfBet), 1)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}